import getters from './getters';
import mutations from './mutations';

export default {
    namespaced: true,
    state() {
        return {
            selectedCableInputTool: 'VIN',
            cablesNeededCount: 0,
            cablesSelectedCount: 0,
            totalCablesSubmittedData: [],
            selectedAdditionalAccessoryOption: "",
            cableSelectionMessage: "",
            cableSelectionMessageType: "general",
        };
    },
    getters,
    mutations,
}